export default {
    namespaced: true,
    state: () => ({
        item: null,
        my_room: null,
    }),
    actions: {
        SOCKET_onGlobalCastPolling({ state, commit }, res){
            console.log('SOCKET_onGlobalCastPolling ->', res);
            if(res.item.room == state.my_room && (state.item == null || state.item.id != res.item.id)){
                commit('setItem', res.item);
            }
        },

        SOCKET_onGlobalStopPolling({ state, commit }, res){
            console.log('SOCKET_onGlobalStopPolling ->', res);
            if(res.item.room == state.my_room && state.item && state.item.id == res.item.id){
                commit('setItem', null);
            }
        },
        
        SOCKET_onGlobalShowPollingResult({ state, commit }, res){
            console.log('SOCKET_onGlobalShowPollingResult ->', res);
            if(res.item.room == state.my_room && res.item.is_cast && state.item && state.item.is_show_result != res.item.is_show_result){
                commit('setItem', res.item);
            }
        },

        SOCKET_onGlobalHidePollingResult({ state, commit }, res){
            console.log('SOCKET_onGlobalHidePollingResult ->', res);
            if(res.item.room == state.my_room && res.item.is_cast && state.item && state.item.is_show_result != res.item.is_show_result){
                commit('setItem', res.item);
            }
        },
    },
    mutations: {
        setItem(state, item){
            state.item = item;
        },
        setMyRoom(state, item){
            state.my_room = item;
            state.item = null;
        },
    }
}

